import { memo } from "react";

import { FeatureIslandHeader } from "@/components/features/_layouts";

export const ManagementRefundRequestTopHeader = memo(() => {
	const title = "返金処理の一覧";

	return <FeatureIslandHeader title={title} />;
});

ManagementRefundRequestTopHeader.displayName = "ManagementRefundRequestTopHeader";
